export default "/_next/static/videos/038016191fc0f5a264d05b38a8cac1b8.mp4";